<template>
  <b-list-group-item class="px-2 py-1" button>
    <b-row align-v="center">
      <b-col cols="1" />
      <b-col> Nothing Found... </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class SuggestionNone extends Vue {}
</script>
